import { observer } from 'mobx-react-lite'
import { GoogleFontLoaderProps } from './Types'
import { useRootStore } from 'stores/RootStore'
import { useEffect, useRef } from 'react'
import { useIntersectionObserver } from 'hooks/useIntersectionObserver'

const GoogleFontLoader = observer(({ family, ...rest }: GoogleFontLoaderProps) => {
  const { googleFonts } = useRootStore()
  const googleFontsIsReady = googleFonts.ready
  const elementRef = useRef<HTMLDivElement>(null)
  const intersection = useIntersectionObserver(elementRef, { threshold: [0, 0.5], ...rest })
  const isVisible = (intersection?.intersectionRatio ?? 0) >= 0.5

  useEffect(() => {
    if (isVisible && googleFontsIsReady) {
      googleFonts.load(family)
    }
  }, [isVisible, googleFontsIsReady]) // eslint-disable-line react-hooks/exhaustive-deps

  return <div ref={elementRef} />
})

export { GoogleFontLoader }
